import React from 'react'
import { jt, t } from 'ttag'

import { MoveResourceModal } from 'components/modals/common/MoveResourceModal/MoveResourceModal'

import { useMoveCandidateModalState } from './hooks'

export const MoveCandidateModal = ({
  name,
  onCancel,
  onClose,
  onConfirm,
  isOpen,
}) => {
  const { state } = useMoveCandidateModalState()

  const { position } = state

  const candidate = <strong key="candidate">{name}</strong>

  return (
    <MoveResourceModal
      alert={jt`You are moving ${candidate}.`}
      title={t`Move candidate`}
      {...{ position, onCancel, onClose, onConfirm, isOpen }}
    />
  )
}
